import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import TableCell from "@material-ui/core/TableCell";

const useStyles = makeStyles(theme => ({
  root: {
    fontWeight: 700,
  },

  active: {
    color: theme.palette.approved,
  },

  inactive: {
    color: theme.palette.inactive,
  },

  deleted: {
    color: theme.palette.rejected,
  },
}));

const StatusTableCell = ({ status, ...props }) => {
  const classes = useStyles();

  return (
    <TableCell
      {...props}
      className={clsx(classes.root, {
        [classes.active]: status === "ACTIVE",
        [classes.deleted]: status === "DELETED",
        [classes.inactive]: status === "INACTIVE",
      })}
    >
      {status}
    </TableCell>
  );
};

export default StatusTableCell;
